

import React from 'react';
import { Day, Week, WorkWeek, Month, Agenda, Inject, ResourcesDirective, ResourceDirective } from '@syncfusion/ej2-react-schedule';
import { useList } from 'hooks/useList';
import SchedulerComponent from 'components/Scheduler/SchedulerComponent';
import { API_ENDPOINTS } from 'constants';
import ApiError from 'components/common/ApiError';
import Skeleton from 'react-loading-skeleton';

export const eventTypeColors = {
    email: '#d048b6', // Green for emails
    todo: '#1f8ef1', // Red for todos
    interaction: '#00d6b4', // Blue for interactions
};

export const transformEmailToEvent = (email) => {
    const startDate = new Date(email.date);
    const endDate = new Date(startDate.getTime() + 60 * 60 * 1000); // 1 hour later
  
    return {
        Id: email.id,
        CalendarId: 1,
        Description: "Email",
        Subject: email.subject,
        StartTime: startDate,
        EndTime: endDate,
        ResourceId: 1,
        CategoryColor: eventTypeColors.email,
      };
};

export const transformTodoToEvent = (todo) => {
    const startDate = new Date(todo.due_date || todo.create_date);
    const endDate = new Date(startDate.getTime() + 30 * 60 * 1000); // 30 minutes later

    return {
        Id: todo.id,
        CalendarId: 1,
        Description: "Todo",
        Subject: todo.headline,
        StartTime: startDate,
        EndTime: endDate,
        ResourceId: 2,
        CategoryColor: eventTypeColors.todo,
      };
};

export const transformInteractionToEvent = (interaction) => {
    const startDate = new Date(interaction.start_time);
    const endDate = new Date(interaction.end_time || startDate.getTime() + 30 * 60 * 1000);
    return {
        Id: interaction.id,
        CalendarId: 1,
        Description: "Interaction",
        Subject: interaction.summary,
        StartTime: startDate,
        EndTime: endDate,
        ResourceId: 3,
        CategoryColor: eventTypeColors.interaction,
    };
};